import React, { useState } from 'react';
import { Form, Input } from '@rocketseat/unform';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';

// 1. Importando o logo e os backgrounds
import logo from '~/assets/Logo Apolar-pretaeazul01.png';
import vetorTartaruga from '~/assets/vetor-tartaruga.png';

import backgroundMobile from '~/assets/apolino-bg-mobile.jpg';
import backgroundDesktop from '~/assets/apolino-bg-desktop.webp';
import { documentMask } from '~/util/documentInputMask';

import { forgetPasswordRequest } from '~/store/modules/auth/actions';

// 2. Importando o MobileLayout e GlobalFonts junto com Content e Loader
import { Content, Loader, MobileLayout, GlobalFonts } from '~/pages/SignIn/styles';

const schema = Yup.object().shape({
  document: Yup.string().required('É obrigatório preencher o documento.'),
});

export default function ForgetPassword() {
  const [document, setDocument] = useState('');
  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);

  async function handleSubmit() {
    dispatch(forgetPasswordRequest(document));
  }

  return (
    <>
      {/* 3. Adicionando fontes globais e o Wrapper com os backgrounds */}
      <GlobalFonts />
      <MobileLayout bgMobile={backgroundMobile} bgDesktop={backgroundDesktop}>
        <Content>
          <img src={vetorTartaruga} style={{ width: '35px' }} alt="Logo Apolar Imóveis" />
          <Loader style={{ display: loading ? 'block' : 'none' }} />
          
          <Form schema={schema} onSubmit={handleSubmit}>
            <h2 className='login-page'>RECUPERAR SENHA</h2>
            <div className="infoForgetPassword">
              Informe seu documento e enviaremos uma nova senha para você.
            </div>
            
            <Input
              maxLength="18"
              name="document"
              placeholder="CPF ou CNPJ"
              value={document}
              onChange={e => {
                setDocument(documentMask(e.target.value));
              }}
              className="inputForgetPassword"
            />

            <button type="submit" className="btn-proximo buttonForgetPassword">
              Enviar nova senha
            </button>
          </Form>
        </Content>
      </MobileLayout>
    </>
  );
}